import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr";

import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Label,
    Input,
    InputGroup,
    Form,
    FormFeedback,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Spinner,
    CardFooter,
    CardTitle,
    FormGroup
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik";

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2.js"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext.js";
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang";
import moment from "moment";
import MyEditor from "components/MyEditor";
import UploadFileS3 from "components/UploadFileS3";
import InputAttachment from "components/Input/attachment/InputAttachment";
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import UploadDesc from "components/UploadDesc";
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner";
import { slugify } from "helpers/fn_helper";

// Services
import {
    SearchPerformanceContent,
    GetPerformanceContentById,
    CreatePerformanceContent,
    UpdatePerformanceContent,
    PatchPerformanceContent,
    DeletePerformanceContent,
} from "./_services/Services.js";

import configWebRoute from "services/api/configWebRoute"
import CardPiecePerformance from "./_components/CardPiecePerformance.js";
import InputText from "components/Input/InputText.jsx";
import { ReactSortable } from "react-sortablejs";
import Error401 from "components/Error401.jsx";

const wr = configWebRoute

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE

const DEF_SORT = [1,2,3,4,5]

const BusinessPurposePerformanceTemplate = ({
    mainId = 1,
    pageView = "create",
    componentKey = "",
}) => {
    const _pageName = `Business Purpose Performance`
    const _routeLink = `business-purpose/performance`
    const _parentComponent = wr.BUSINESS_PURPOSE
    const _routePermission = `business-purpose:section-4`

    // POPUP
    const { mAlert } = useContext(ModalContext);

    // OTHER STATE
    const qParams = useParams()
    const qLang = _.upperCase(qParams?.lang) ?? 'TH'
    // const qMainId = 1
    // const componentKey = qParams?.componentKey
    const navigate = useNavigate();
    
    const [waitSendData, setWaitSendData] = useState(false)
    const [contentLoading, setContentLoading] = useState(false)

    const [contentCard1Show, setcontentCard1Show] = useState(false)
    const [contentCard2Show, setcontentCard2Show] = useState(false)
    const [contentCard3Show, setcontentCard3Show] = useState(false)
    const [contentCard4Show, setcontentCard4Show] = useState(false)
    const [contentCard5Show, setcontentCard5Show] = useState(false)

    const [cardSeq, setCardSeq] = useState(DEF_SORT)

    const mainIdDb = mainId;
    // ========== Form Validation ========== //
    const validationSchema = Yup.object({
        contentName: Yup.string().required("Please Enter Section Text"),
        contentDetail: Yup.string().required("Please Enter Section Detail"),

        contentCard1Show: Yup.boolean(),
        // contentCard1Image: Yup.object().test(
        //     "is-not-empty-object",
        //     "Please Upload Image Box",
        //     (value) => value && Object.keys(value).length > 0
        // ).required("Please Upload Card 1 Image"),
        contentCard1Detail: Yup.string().max(255),
        contentCard1Number: Yup.string().max(100),
        contentCard1Unit: Yup.string().max(100),

        contentCard2Show: Yup.boolean(),
        // contentCard2Image: Yup.object().test(
        //     "is-not-empty-object",
        //     "Please Upload Image Box",
        //     (value) => value && Object.keys(value).length > 0
        // ).required("Please Upload Card 2 Image"),
        contentCard2Detail: Yup.string().max(255),
        contentCard2Number: Yup.string().max(100),
        contentCard2Unit: Yup.string().max(100),

        contentCard3Show: Yup.boolean(),
        // contentCard3Image: Yup.object().test(
        //     "is-not-empty-object",
        //     "Please Upload Image Box",
        //     (value) => value && Object.keys(value).length > 0
        // ).required("Please Upload Card 3 Image"),
        contentCard3Detail: Yup.string().max(255),
        contentCard3Number: Yup.string().max(100),
        contentCard3Unit: Yup.string().max(100),

        contentCard4Show: Yup.boolean(),
        // contentCard4Image: Yup.object().test(
        //     "is-not-empty-object",
        //     "Please Upload Image Box",
        //     (value) => value && Object.keys(value).length > 0
        // ).required("Please Upload Card 4 Image"),
        contentCard4Detail: Yup.string().max(255),
        contentCard4Number: Yup.string().max(100),
        contentCard4Unit: Yup.string().max(100),

        contentCard5Show: Yup.boolean(),
        // contentCard5Image: Yup.object().test(
        //     "is-not-empty-object",
        //     "Please Upload Image Box",
        //     (value) => value && Object.keys(value).length > 0
        // ).required("Please Upload Card 5 Image"),
        contentCard5Detail: Yup.string().max(255),
        contentCard5Number: Yup.string().max(100),
        contentCard5Unit: Yup.string().max(100),

        contentUpdateDate: Yup.string().max(100),
        contentStatus: Yup.string().max(100),
    })


    // LOCAL STATE FORM
    const [updatedValidationSchema, setUpdatedValidationSchema] = useState(validationSchema)

    const initialValues = {
        contentId: "",

        // Content
        contentName: "",
        contentDetail: "",

        contentCard1Show: "",
        contentCard1Detail: "",
        contentCard1Number: "",
        contentCard1Unit: "",

        contentCard2Show: "",
        contentCard2Detail: "",
        contentCard2Number: "",
        contentCard2Unit: "",

        contentCard3Show: "",
        contentCard3Detail: "",
        contentCard3Number: "",
        contentCard3Unit: "",

        contentCard4Show: "",
        contentCard4Detail: "",
        contentCard4Number: "",
        contentCard4Unit: "",

        contentCard5Show: "",
        contentCard5Detail: "",
        contentCard5Number: "",
        contentCard5Unit: "",

        card1Image: {},
        card2Image: {},
        card3Image: {},
        card4Image: {},
        card5Image: {},

        contentUpdateDate: moment().format('YYYY-MM-DD'),
        contentStatus: "active",
    }

 

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: updatedValidationSchema,
        onSubmit: values => {
            console.log("🚀 ~ ExecutivesPageCreate ~ values:", values)

            const valueSort = fnSortCardSeq(cardSeq,
                [
                    {
                        contentCardShow: values.contentCard1Show,
                        contentCardDetail: values.contentCard1Detail,
                        contentCardNumber: values.contentCard1Number,
                        contentCardUnit: values.contentCard1Unit,
                        cardImage: values.card1Image,
                    },
                    {
                        contentCardShow: values.contentCard2Show,
                        contentCardDetail: values.contentCard2Detail,
                        contentCardNumber: values.contentCard2Number,
                        contentCardUnit: values.contentCard2Unit,
                        cardImage: values.card2Image,
                    },
                    {
                        contentCardShow: values.contentCard3Show,
                        contentCardDetail: values.contentCard3Detail,
                        contentCardNumber: values.contentCard3Number,
                        contentCardUnit: values.contentCard3Unit,
                        cardImage: values.card3Image,
                    },
                    {
                        contentCardShow: values.contentCard4Show,
                        contentCardDetail: values.contentCard4Detail,
                        contentCardNumber: values.contentCard4Number,
                        contentCardUnit: values.contentCard4Unit,
                        cardImage: values.card4Image,
                    },
                    {
                        contentCardShow: values.contentCard5Show,
                        contentCardDetail: values.contentCard5Detail,
                        contentCardNumber: values.contentCard5Number,
                        contentCardUnit: values.contentCard5Unit,
                        cardImage: values.card5Image,
                    }
                ]
            )

            const payload = {
                componentKey: componentKey,

                contentName: values.contentName,
                contentDetail: values.contentDetail,

                contentCard1Show: valueSort[0]?.contentCardShow,
                contentCard1Detail: valueSort[0]?.contentCardDetail,
                contentCard1Number: valueSort[0]?.contentCardNumber,
                contentCard1Unit: valueSort[0]?.contentCardUnit,

                contentCard2Show: valueSort[1]?.contentCardShow,
                contentCard2Detail: valueSort[1]?.contentCardDetail,
                contentCard2Number: valueSort[1]?.contentCardNumber,
                contentCard2Unit: valueSort[1]?.contentCardUnit,

                contentCard3Show: valueSort[2]?.contentCardShow,
                contentCard3Detail: valueSort[2]?.contentCardDetail,
                contentCard3Number: valueSort[2]?.contentCardNumber,
                contentCard3Unit: valueSort[2]?.contentCardUnit,

                contentCard4Show: valueSort[3]?.contentCardShow,
                contentCard4Detail: valueSort[3]?.contentCardDetail,
                contentCard4Number: valueSort[3]?.contentCardNumber,
                contentCard4Unit: valueSort[3]?.contentCardUnit,

                contentCard5Show: valueSort[4]?.contentCardShow,
                contentCard5Detail: valueSort[4]?.contentCardDetail,
                contentCard5Number: valueSort[4]?.contentCardNumber,
                contentCard5Unit: valueSort[4]?.contentCardUnit,

                attachmentData: {
                    
                },

                contentAttachmentData: {
                    card1Image: valueSort[0]?.cardImage ? valueSort[0].cardImage : undefined,
                    card2Image: valueSort[1]?.cardImage ? valueSort[1].cardImage : undefined,
                    card3Image: valueSort[2]?.cardImage ? valueSort[2].cardImage : undefined,
                    card4Image: valueSort[3]?.cardImage ? valueSort[3].cardImage : undefined,
                    card5Image: valueSort[4]?.cardImage ? valueSort[4].cardImage : undefined,
                },

                contentUpdateDate: values.contentUpdateDate,
                contentStatus: values.contentStatus,
            };

            console.log("🚀 ~ onSave ~ payload:", payload);

            setWaitSendData(true)
            if (pageView === "update") {
                API.fetchUpdateContent(payload)
            } else {
                API.fetchCreateContent(payload)
            }
        },
    })

    const fnSortCardSeq = (seqNoSort = [], valueList = []) => {
        let newValueList = []
        for (let no of seqNoSort) {
            console.log('no', no)
            const valueWithNo = valueList.find((item,i) => (i + 1)  == no)
            newValueList.push(valueWithNo)
        }

        return newValueList
    }

    // Handle the end of sorting to update the card sequence
    const handleSortEnd = (newSeq) => {
        setCardSeq(newSeq);  // Update the cardSeq state
        validation.setFieldValue("cardSeq", newSeq);  // Synchronize with Formik
    };

    const preFilInput = (resData = {}) => {
        console.log("🚀 ~ preFilInputPage ~ resData:", resData)
        // resetForm(validation.values, initialValues)
        validation.setFieldValue("contentId", resData?.contentId ?? "")

        validation.setFieldValue("contentName", resData?.contentName ?? "")
        validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")

        setcontentCard1Show(resData?.contentCard1Show ?? false)
        validation.setFieldValue("contentCard1Show", resData?.contentCard1Show ?? "")
        validation.setFieldValue("contentCard1Detail", resData?.contentCard1Detail ?? "")
        validation.setFieldValue("contentCard1Number", resData?.contentCard1Number ?? "")
        validation.setFieldValue("contentCard1Unit", resData?.contentCard1Unit ?? "")

        setcontentCard2Show(resData?.contentCard2Show ?? false)
        validation.setFieldValue("contentCard2Show", resData?.contentCard2Show ?? "")
        validation.setFieldValue("contentCard2Detail", resData?.contentCard2Detail ?? "")
        validation.setFieldValue("contentCard2Number", resData?.contentCard2Number ?? "")
        validation.setFieldValue("contentCard2Unit", resData?.contentCard2Unit ?? "")

        setcontentCard3Show(resData?.contentCard3Show ?? false)
        validation.setFieldValue("contentCard3Show", resData?.contentCard3Show ?? "")
        validation.setFieldValue("contentCard3Detail", resData?.contentCard3Detail ?? "")
        validation.setFieldValue("contentCard3Number", resData?.contentCard3Number ?? "")
        validation.setFieldValue("contentCard3Unit", resData?.contentCard3Unit ?? "")

        setcontentCard4Show(resData?.contentCard4Show ?? false)
        validation.setFieldValue("contentCard4Show", resData?.contentCard4Show ?? "")
        validation.setFieldValue("contentCard4Detail", resData?.contentCard4Detail ?? "")
        validation.setFieldValue("contentCard4Number", resData?.contentCard4Number ?? "")
        validation.setFieldValue("contentCard4Unit", resData?.contentCard4Unit ?? "")

        setcontentCard5Show(resData?.contentCard5Show ?? false)
        validation.setFieldValue("contentCard5Show", resData?.contentCard5Show ?? "")
        validation.setFieldValue("contentCard5Detail", resData?.contentCard5Detail ?? "")
        validation.setFieldValue("contentCard5Number", resData?.contentCard5Number ?? "")
        validation.setFieldValue("contentCard5Unit", resData?.contentCard5Unit ?? "")

        validation.setFieldValue("card1Image", resData?.contentCard1Image ?? "")
        validation.setFieldValue("card2Image", resData?.contentCard2Image ?? "")
        validation.setFieldValue("card3Image", resData?.contentCard3Image ?? "")
        validation.setFieldValue("card4Image", resData?.contentCard4Image ?? "")
        validation.setFieldValue("card5Image", resData?.contentCard5Image ?? "")

        validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format('YYYY-MM-DD'))
        validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")
    }

    const API = {
        fetchGetContentById: async (mainId) => {
            try {
                const response = await GetPerformanceContentById(mainId, {
                    lang: qLang,
                })
                const resData = response?.data
                if (resData.status == 200) {
                    preFilInput(resData.data)
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong 001",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setContentLoading(false)
            }
        },
        fetchCreateContent: async (payload) => {
            try {
                const response = await CreatePerformanceContent({ data: payload, lang: qLang })
                const resData = response.data
                if (resData.status == 201) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Created Data Success",
                        content: "",
                        onClose: () => {
                            navigate(`/${_routeLink}/performance/${qLang}`)
                            window.location.reload()
                        },
                    })
                }
            } catch (e) {
                console.log(e)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
        fetchUpdateContent: async (payload) => {
            try {
                const response = await UpdatePerformanceContent(mainIdDb, {
                    data: payload,
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 202) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Update Data Success",
                        content: "",
                        onClose: () => {
                            navigate(
                                window.location.reload()
                            )
                        },
                    })
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
    }

    // กรณี Edit
    useEffect(() => {
        if (["update", "view"].includes(pageView)) {
            setContentLoading(true)
            API.fetchGetContentById(mainIdDb)
        }
    }, [qLang])

    useEffect(() => {
        console.log('validation.values', validation.values)
    }, [])

    const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
    document.title = `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

    const itemStyle = {
        padding: '10px',
        border: '1px solid black',
        margin: '5px',
        borderRadius: '8px',
        background: '#f9f9f9',
        transition: 'transform 0.2s ease, background-color 0.3s ease',
    };

    const mapValues = (list = []) => list.map(item => {
        const newObj = {
            attachmentId: item.attachmentId,
            sequence: item.sequence
        }
        return newObj
    })

    if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
        return <Error401 />
      }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={`${PAGE_VIEW} ${_pageName}`}
                        breadcrumbItems={[
                            { title: _pageName, link: "" },
                            { title: PAGE_VIEW },
                        ]}
                    />

                    {/* Render Form */}
                    {
                        contentLoading
                            ? <Spinners setLoading={setContentLoading} />
                            :
                            <Row>
                                <Col className="col-12">
                                    <FormikProvider value={validation}>
                                        <Form
                                            className="form-horizontal"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            <Row>
                                                <Col className="col-8">
                                                    <Card>
                                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                                            <i className='bx bx-cube-alt'></i> {_pageName}
                                                        </h5>
                                                        <CardBody>
                                                            <Row>
                                                                <Col md={12}>
                                                                    <label
                                                                        htmlFor="contentName"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Section Name
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        
                                                                        <InputText
                                                                            id="contentName"
                                                                            className="form-control"
                                                                            type="text"
                                                                            placeholder=""
                                                                            name="contentName"
                                                                            onChange={e => {
                                                                                validation.setFieldValue(
                                                                                    "contentName",
                                                                                    e.target.value
                                                                                )
                                                                            }}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.contentName}
                                                                            invalid={
                                                                                validation.touched.contentName &&
                                                                                    validation.errors.contentName
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            disabled={pageView === "view"}
                                                                            maxLength={9999}
                                                                        />
                                                                        {validation.touched.contentName &&
                                                                            validation.errors.contentName && (
                                                                                <FormFeedback type="invalid">
                                                                                    {validation.errors.contentName}
                                                                                </FormFeedback>
                                                                            )}
                                                                    </div>
                                                                    <hr />
                                                                </Col>
                                                                <Col md={12} className="mb-3">
                                                                    <Label
                                                                        htmlFor="contentDetail"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Section Detail
                                                                        <span className="t-require">*</span>
                                                                    </Label>
                                                                    <Col md={12}>
                                                                        <MyEditor
                                                                            id="contentDetail"
                                                                            placeholder=""
                                                                            name="contentDetail"
                                                                            onChange={(e, editor) => {
                                                                                const data = editor.getData()
                                                                                validation.setFieldValue(
                                                                                    "contentDetail",
                                                                                    data
                                                                                )
                                                                                console.log({ e, editor, data })
                                                                            }}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.contentDetail}
                                                                            invalid={
                                                                                validation.touched.contentDetail &&
                                                                                    validation.errors.contentDetail
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            disabled={pageView === "view"}
                                                                            isError={
                                                                                validation.touched.contentDetail &&
                                                                                    validation.errors.contentDetail
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                        />
                                                                        {validation.touched.contentDetail &&
                                                                            validation.errors.contentDetail && (
                                                                                <FormFeedback type="invalid">
                                                                                    {validation.errors.contentDetail}
                                                                                </FormFeedback>
                                                                            )}
                                                                    </Col>
                                                                </Col>
                                                                <hr />
                                                            </Row>
                                                            <ReactSortable
                                                                list={cardSeq}
                                                                setList={handleSortEnd}
                                                                animation={150}
                                                                id="sort-performance"
                                                                className="row"
                                                                handle=".drag-handle"
                                                            >
                                                                { cardSeq.map((itemNo, index) => {
                                                                    const tmpConfig = {
                                                                        '1': contentCard1Show,
                                                                        '2': contentCard2Show,
                                                                        '3': contentCard3Show,
                                                                        '4': contentCard4Show,
                                                                        '5': contentCard5Show,
                                                                    }

                                                                    if (tmpConfig[itemNo] == undefined) {
                                                                        return <></>
                                                                    }
                                                                    return <CardPiecePerformance key={itemNo} runningNo={index+1} pageView={pageView} validation={validation} cardNumber={itemNo} contentCardShow={tmpConfig[itemNo]}/>
                                                                })}
                                                            </ReactSortable>
                                                            
                                                            {/* <Row id="sort-performance">
                                                                {contentCard1Show !== undefined && <CardPiecePerformance pageView={pageView} validation={validation} cardNumber={1} contentCardShow={contentCard1Show}/>}
                                                                {contentCard2Show !== undefined && <CardPiecePerformance pageView={pageView} validation={validation} cardNumber={2} contentCardShow={contentCard2Show}/>}
                                                                {contentCard3Show !== undefined && <CardPiecePerformance pageView={pageView} validation={validation} cardNumber={3} contentCardShow={contentCard3Show}/>}
                                                                {contentCard4Show !== undefined && <CardPiecePerformance pageView={pageView} validation={validation} cardNumber={4} contentCardShow={contentCard4Show}/>}
                                                                {contentCard5Show !== undefined && <CardPiecePerformance pageView={pageView} validation={validation} cardNumber={5} contentCardShow={contentCard5Show}/>}
                                                            </Row> */}
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                                <Col className="col-4">
                                                    <Card outline color="primary" className="border sticky-element">
                                                        <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                                            <i className='bx bx-check'></i> Tools Box
                                                        </h5>
                                                        <CardBody>
                                                            <Row>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Switch Language
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <InputLang widthfull pageView={pageView} forceRoute={false} />
                                                                    </div>
                                                                </Col>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Written at
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <InputGroup>
                                                                            <Flatpickr
                                                                                className="form-control d-block"
                                                                                options={{
                                                                                    dateFormat: 'd/m/Y', // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                                                                }}
                                                                                value={validation.values.contentUpdateDate ? moment(validation.values.contentUpdateDate, 'YYYY-MM-DD').toDate() : null}
                                                                                disabled={true}
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-secondary docs-datepicker-trigger"
                                                                                    disabled
                                                                                >
                                                                                    <i className="fa fa-calendar" aria-hidden="true" />
                                                                                </button>
                                                                            </div>
                                                                        </InputGroup>
                                                                        {
                                                                            (validation.touched.contentUpdateDate && validation.errors.contentUpdateDate) && (
                                                                                <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentUpdateDate}</div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </Col>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Display
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <Select
                                                                            placeholder="Select Status"
                                                                            value={fn_helper.FNFORM.getObjectValue(STATUS_OPTION, `${validation.values.contentStatus}`)}
                                                                            onChange={(value) => validation.setFieldValue("contentStatus", value.id)}
                                                                            getOptionValue={(option) => option.id}
                                                                            getOptionLabel={(option) => option.name}
                                                                            options={STATUS_OPTION}
                                                                            className={`select2-selection ${validation.touched.contentStatus && validation.errors.contentStatus ? "input-err" : ""}`}
                                                                            isDisabled={pageView === "view"}
                                                                        />
                                                                        {
                                                                            (validation.touched.contentStatus && validation.errors.contentStatus) && (
                                                                                <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentStatus}</div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                        <CardFooter>
                                                            <Row>
                                                                {/* <Col className="text-start">
                                                                    <Button color="danger" className="btn btn-danger" onClick={() => navigate(`/pdpa/page-setting/${qLang}`)}>Back</Button>
                                                                </Col> */}
                                                                <Col className="text-end">
                                                                    {pageView !== 'view' && (
                                                                        <Button type="submit" className="btn btn-success">
                                                                            Save  {waitSendData ? <Spinner size="sm" color="light" /> : null}
                                                                        </Button>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </CardFooter>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </FormikProvider>
                                </Col>
                            </Row>
                    }
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withTranslation()(BusinessPurposePerformanceTemplate)
